import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Stack,
  TextField,
  Typography
} from '@material-ui/core';

import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import LeakRemoveIcon from '@material-ui/icons/LeakRemove';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { baseUrl } from '../../utils/constants';
import { useClaimsContext } from '../../context/claims_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';
import ClaimsLine from './ClaimsLine';
import LineOverride from './LineOverride';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'tarrifC', label: 'Tariff #', alignRight: true },
  { id: 'tariff', label: 'Description', alignRight: false },
  { id: 'status', label: 'Qty', alignRight: true },
  { id: 'tar', label: 'Tarrif Amt', alignRight: true },
  { id: 'char', label: 'Fee Charged', alignRight: true },
  { id: 'aa' },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClaimSubform() {
  const { claimNo, claimDetailsList, currentClaim, refreshClaimLineById } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();

  // useEffect(() => {
  //   // console.log('claimNo is in ClaimsSubform ', claimNo);
  //   // if (claimNo < 0) setClaimDetailsList([]);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleLineDelete = async (e) => {
    console.log('e here', e.claimDtl_id);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/claims/deleteClaimDetail?claimDtl_id=${e.claimDtl_id}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Claim Detail!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Claim Detail Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Claim Detail!: ${error}`, 'error');
      }
    );
  };

  const handleLineView = (e) => {
    console.log('e claimLineId ', e);
    refreshClaimLineById(e.claimDtl_id);
    openView();
  };

  const handleOverride = (e) => {
    console.log('e claimLineId ', e);
    // refreshClaimLineById(e.claimDtl_id);
    openView();
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const openView = () => {
    setOpenPopup(true);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - claimDetailsList.length) : 0;

  const filteredUsers = applySortFilter(
    claimDetailsList,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  const totalInvoice = claimDetailsList.reduce((sum, value) => sum + value.amtClaimed, 0);

  return (
    <Container>
      <Stack direction="row" alignItems="right" justifyContent="end" mt="10" pt="3">
        <Typography variant="h6" gutterBottom>
          Total Services...
        </Typography>
        <TextField
          size="small"
          id="currBalance"
          // label="Current Balance"
          InputProps={{
            inputComponent: Controls.NumberDecimal,
            style: { textAlign: 'right' }
          }}
          value={totalInvoice}
        />
      </Stack>
      <Card>
        <Scrollbar>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={claimDetailsList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      claimDtl_id,
                      tarif_Code,
                      units,
                      tariff_desc,
                      amtClaimed,
                      tariffAmt,
                      status_Code
                    } = row;
                    const isItemSelected = selected.indexOf(claimDtl_id) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={claimDtl_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{tarif_Code}</TableCell>

                        <TableCell align="left">{tariff_desc}</TableCell>
                        <TableCell align="right">{units}</TableCell>
                        <TableCell align="right">{tariffAmt.toFixed(2)}</TableCell>
                        <TableCell align="right">{amtClaimed.toFixed(2)}</TableCell>
                        {/* <IconButton onClick={() => handleLineView({ claimDtl_id })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton> */}
                        <TableCell align="right">
                          {currentClaim.status_Id === 1 && (
                            <IconButton
                              onClick={() =>
                                setConfirmDialog({
                                  isOpen: true,
                                  title: 'Are you sure you want to Delete Entry',
                                  subTitle: "You can't undo this action",
                                  heading: 'Delete Claim Detail',
                                  color: '#00000',
                                  onConfirm: () => {
                                    handleLineDelete({ claimDtl_id });
                                  }
                                })
                              }
                            >
                              <DeleteForeverIcon sx={{ color: '#f44336' }} />
                            </IconButton>
                          )}
                          {currentClaim.status_Id === 1 && (
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOverride({ claimDtl_id });
                              }}
                            >
                              <EditIcon sx={{ color: '#0c5935' }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.Popup
            title="Update Detail Line"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <LineOverride closePopup={closePopup} claim_ID={claimNo} />
          </Controls.Popup>
        </Scrollbar>

        <TablePagination
          // className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={claimDetailsList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* <Controls.Popup title="Override Line" openPopup={openPopupOv} setOpenPopup={setOpenPopupOv}>
        <LineOverride closePopup={closePopupOv} claim_ID={claimNo} />
      </Controls.Popup> */}
      <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
    </Container>
  );
}
